export default {
    revision: null,
    projectInfo: null,
    npdTickets: [],
    options: {
        leedProject: [],
        drafters: [],
        quotes: [],
        architecturalDrawings: [],
        rejections: [],
        request_types: [],
        linkedOrders: [],
        difficultyLevels: [],
    },
    filterData: {
        drafters: [],
        request_types: [],
        statuses: [],
        estimators: [],
        po_owners: [],
    },
    shopsList: {
        refreshList: false,
        filtersOpen: false,
        filters: {
            per_page: 20,
            only_my: false,
            filter: '',
            drafters: [],
            request_types: [],
            statuses: [],
            estimators: [],
            po_owners: [],
        },
    },
    actionRequiredList: {
        refreshList: false,
        filtersOpen: false,
        filters: {
            drafters: [],
            request_types: [],
            statuses: [],
            estimators: [],
            po_owners: [],
            include_linked_requests: false
        },
    },
    signedShopPromptOpen: false,
    cancelShopPromptOpen: false,
    cancelShopAdditionalRequestPromptOpen: false,
    newShopRequestPromptOpen: false,
    linkShopRequestPromptOpen: false,
    linkShopPromptOnlyInstDetails: false,
    holdShopPromptOpen: false,
    dwgGenerationModalOpen: false,
    cadGenerationModalOpen: false,
    regenerateCadModalOpen: false,
    estDateCalculationModalOpen: false,
    editingTaskInfo: false,
    holdStatuses: [],
    errors: {
        taskInfo: {},
    },
    timelineFirstPageUrl: undefined,
    unassignedActionRequiredCount: 0,
    workloadActionRequiredCount: 0,
    assignedActionRequiredCount: 0,
    failedAction: null,
    linkedInstDetails: null,
    signedShopDrawings: [],
    showSignedShopsLoader: false,
    bluescreenRevisionDetails: [],
};
